<template>
  <v-container>
    <v-layout justify-center row>
      <v-flex sm8 md6 lg5>
    <v-form @submit.prevent="onSubmit" novalidate class="elevation-2 pa-3">
      <Fields
        v-bind="{fields, object: formData, errors: formErrors}">
          <template slot="fieldRunner" slot-scope="{field, error, errorMessages}">
            <runner-select
              class="mr-2"
              v-model="formData.runner"
              @input="changeRunner"
              :error="error"
              :error-messages="errorMessages"
              ></runner-select>
          </template>
          <template slot="fieldDocument" slot-scope="{field}">
            <div v-if="formData.document_url">
              <a :href="formData.document_url">
                {{formData.document_filename}}</a>
              <v-icon class="ml-2" v-tooltip="'Usuń'" @click.stop="deleteFile">close</v-icon>
            </div>
            <file-upload v-else target="uploads/" action="POST" @finish="finish" small></file-upload>
          </template>
      </Fields>

      <v-btn type="submit" color="primary">Zapisz</v-btn>
    </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import {createPayment, updatePayment} from './api'
import {getRunner} from '@/runners/api'
import _ from 'lodash'
import Fields from '@/forms/Fields'
import formMixin from '@/utils/formMixin'
import RunnerSelect from '@/runners/RunnerSelect'
import FileUpload from '@/utils/FileUpload'
import moment from 'moment'

export default {
  components: {Fields, RunnerSelect, FileUpload},
  mixins: [formMixin],
  props: {
    userPayment: {
      type: Object,
      default: function () {
        let today = moment().startOf('month')
        let dueDate = moment().startOf('month').add(7, 'd')
        return {
          period: moment(today).format('YYYY-MM'),
          due_date: moment(dueDate).format('YYYY-MM-DD')
        }
      }
    }
  },
  data () {
    return {
      runner: null,
      isUpdate: false,
      formData: {
        runner: null,
        price: 0
      }
    }
  },
  computed: {
    fields () {
      return [
        {comp: 'date', id: 'period', label: 'Okres', props: {month: true}},
        {comp: 'text', id: 'runner', label: 'Zawodnik'},
        {comp: 'text', id: 'price', label: 'Cena'},
        {comp: 'date', id: 'due_date', label: 'Termin płatności'},
        {comp: 'text', id: 'document', label: 'Plik'}
      ]
    },
    message () {
      return this.isUpdate ? 'Płatność została edytowana' : 'Płatność została dodana'
    }
  },
  created () {
    this.formData = _.cloneDeep(this.userPayment)
    if (this.userPayment.id) {
      this.isUpdate = true
      this.formData.document = undefined
    }
  },
  methods: {
    deleteFile () {
      this.formData.document = null
      this.formData.document_url = null
    },
    finish (e) {
      if (e.data && e.data.id) {
        this.formData.document = e.data.id
      }
    },
    changeRunner () {
      if (this.formData.runner) {
        getRunner(this.formData.runner).then((data) => {
          this.$set(this.formData, 'price', data.price)
        })
      }
    },
    submit (data) {
      if (this.isUpdate) {
        return updatePayment(data)
      } else {
        return createPayment(data).then((data) => {
          this.formData = {runner: null, price: 0}
          this.validation.reset()
          return data
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/payments/PaymentForm.vue